export default {
    API_URL: process.env.REACT_APP_API_URL,
    AUTH_TOKEN_KEY: process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY
}